import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AboutPro } from 'src/app/core/objects/payment';
import { User } from 'src/app/core/objects/user';
import { PaymentService } from 'src/app/core/services/payment.service';
import { UserService } from 'src/app/core/services/user.service';
import DateGenerator from 'src/app/core/utils/date-generator';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { LanguageService } from '../../core/services/language.service';
import { Router } from '@angular/router';

@Component({
    selector: 'gl-prolong-popup',
    templateUrl: './prolong-popup.component.html',
    styleUrls: ['./prolong-popup.component.scss'],
    standalone: false
})
export class ProlongPopupComponent implements OnDestroy {
  public endDatePro: string;
  public user: User;
  private subscription: Subscription;

  constructor(
    private modalRef: ModalOverlayRef,
    private router: Router,
    private paymentService: PaymentService,
    private userService: UserService,
    private languageService: LanguageService
  ) {
    this.modalRef.backgroundClicked();
    this.user = this.userService.getState();
    this.subscription = this.paymentService.pro.subscribe((aboutPro: AboutPro) => {
      const arrayData = aboutPro.endPeriodDate?.split('.');
      const date = new Date(arrayData?.[1] + '/' + arrayData?.[2] + '/' + arrayData?.[0]);
      date.setUTCDate(date.getDate());
      this.endDatePro = DateGenerator.createDate(date);
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public openPriceList(): void {
    this.close(true);
    const defaultLanguage = this.languageService.getDefaultLanguage();
    this.router.navigateByUrl(`/${defaultLanguage}/account/subscription/priceList`);
  }

  public close(result: boolean) {
    this.modalRef.close(result);
  }
}
